module.exports = __webpack_public_path__ + "img/toolbar_bg2.fa1d1961.jpg";